import { ApplicationRef, Injectable } from "@angular/core";
import { configureChains, connect, fetchBalance, prepareWriteContract, readContracts, switchNetwork, watchAccount, watchNetwork, writeContract, disconnect, waitForTransaction, createConfig } from '@wagmi/core';
import { HttpClient } from "@angular/common/http";
import { jsonRpcProvider } from '@wagmi/core/providers/jsonRpc';
import { publicProvider } from '@wagmi/core/providers/public';

import { bsc, bscTestnet } from "viem/chains";
import { MetaMaskConnector } from '@wagmi/core/connectors/metaMask';
import { WalletConnectConnector } from '@wagmi/core/connectors/walletConnect';
import { Web3Auth } from "@web3auth/modal";
import { encodeFunctionData, formatEther, parseEther } from "viem";
import { TranslateService } from "@ngx-translate/core";
import { CHAIN_NAMESPACES } from "@web3auth/base";
import { Web3AuthConnector } from "@web3auth/web3auth-wagmi-connector";


import { PopupService } from "./popup.service";
import { EventService } from "./event.service";
import { EVENTS, getBrowserName, getClickId, getParam, getParamWithoutCookie, getSource, SwapStatus } from "../shared/constants/app-enums";
import { environment } from "src/environments/environment";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import { AuthAdapter } from "@web3auth/auth-adapter";
import { WalletServicesPlugin } from "@web3auth/wallet-services-plugin";


const presaleBsc = require('src/assets/contracts/presaleBSC.json');
const bsc_usdt_token = require('src/assets/contracts/bsc_usdt_token.json');
const token = require('src/assets/contracts/token.json');
const staking = require('src/assets/contracts/staking.json');


const presaleContractBsc = {
  address: environment.bsc.presaleAddress as any,
  abi: presaleBsc.abi,
}
const stakeContract = {
  address: environment.stakingAddress as any,
  abi: staking.abi,
}

const bscUsdtContract = {
  address: environment.bsc.usdTAddress as any,
  abi: bsc_usdt_token.abi,
}

const tokenContract = {
  address: environment.tokenAddress as any,
  abi: token.abi,
}

const web3clientId = environment.web3clientId
const googleClientId = environment.googleClientId
const torusWalletId = environment.torusWalletId

@Injectable({
  providedIn: 'root'
})

export class WalletConnectService {

  swapStatus = SwapStatus.not_started;
  client: any;
  wagmiData: any;
  walletAddress: string = '';
  referUrl = '';
  chainId: any;
  mode: any;
  listnerAdded = false;
  balanceData: {
    nativeBal: number,
    usdtBal: number,
    ethTokenSold: number,
    bscTokenSold: number,
    totalTokensSold: number,
    ethClaimable?: number,
    bscClaimable?: number,
    userClaimable: number,
    currentStep: number,
    startTime?: any,
    endTime?: any,
    paused?: boolean,
    usdRaised?: number,
    oneEth: number,
    oneBnb: number,
    tokenNum: number,
    ethUsdt: number,
    bnbUsdt: number
  } = {
      nativeBal: 0,
      usdtBal: 0,
      ethTokenSold: 0,
      bscTokenSold: 0,
      totalTokensSold: 0,
      ethClaimable: 0,
      bscClaimable: 0,
      userClaimable: 0,
      startTime: '',
      endTime: '',
      paused: false,
      currentStep: 0,
      usdRaised: 0,
      oneEth: 0,
      oneBnb: 0,
      ethUsdt: 0,
      bnbUsdt: 0,
      tokenNum: 0
    }
  stakeData: {
    userStaked: number,
    totalStaked: number,
    rewardPerRound: number,
    userPoolPercent: number,
    apy: number,
    unlockTime: number,
    userReward: number,
    userBal: number,
    isClaimEnabled: boolean,
    claimDate: number
  } = {
      userStaked: 0,
      totalStaked: 0,
      rewardPerRound: 0,
      userPoolPercent: 0,
      apy: 0,
      unlockTime: 0,
      userReward: 0,
      userBal: 0,
      isClaimEnabled: false,
      claimDate: 0
    }
  burnData: {
    totalSupply: number,
    totalBurnt: number,
    totalBurntCommunity: number,
  } = {
      totalSupply: 0,
      totalBurnt: 0,
      totalBurntCommunity: 0,
    }
  metaMaskConnector: any;
  walletConnector: any;
  web3AuthConnector: any;
  web3AuthInstance: Web3Auth | null = null;
  walletConnectorBW: any;
  uriConnector: any;

  presaleData: any;
  swapHash: any = '';
  refreshId: any;
  refreshRate: number = 10000;
  okWebSocket: boolean = false;
  tokenomics = [
    {
      "minToken": 0,
      "maxToken": 20000000,
      "maxAmount": 500000,
      "tokenUSDT": 0.025,
      "title": "stage_1",
      "endDate": 1684936022000
    },
    {
      "minToken": 20000000,
      "maxToken": 40000000,
      "maxAmount": 1006000,
      "tokenUSDT": 0.0253,
      "title": "stage_2",
      "endDate": 1685368022000
    },
    {
      "minToken": 40000000,
      "maxToken": 60000000,
      "maxAmount": 1518000,
      "tokenUSDT": 0.0256,
      "title": "stage_3",
      "endDate": 1685800022000
    },
    {
      "minToken": 60000000,
      "maxToken": 80000000,
      "maxAmount": 2036000,
      "tokenUSDT": 0.0259,
      "title": "stage_4",
      "endDate": 1686232022000
    },
    {
      "minToken": 80000000,
      "maxToken": 100000000,
      "maxAmount": 2560000,
      "tokenUSDT": 0.0262,
      "title": "stage_5",
      "endDate": 1686664022000
    },
    {
      "minToken": 100000000,
      "maxToken": 120000000,
      "maxAmount": 3090000,
      "tokenUSDT": 0.0265,
      "title": "stage_6",
      "endDate": 1687096022000
    },
    {
      "minToken": 120000000,
      "maxToken": 140000000,
      "maxAmount": 3626000,
      "tokenUSDT": 0.0268,
      "title": "stage_7",
      "endDate": 1687528022000
    },
    {
      "minToken": 140000000,
      "maxToken": 160000000,
      "maxAmount": 4168000,
      "tokenUSDT": 0.0271,
      "title": "stage_8",
      "endDate": 1687960022000
    },
    {
      "minToken": 160000000,
      "maxToken": 180000000,
      "maxAmount": 4716000,
      "tokenUSDT": 0.0274,
      "title": "stage_9",
      "endDate": 1688392022000
    },
    {
      "minToken": 180000000,
      "maxToken": 200000000,
      "maxAmount": 5270000,
      "tokenUSDT": 0.0277,
      "title": "stage_10",
      "endDate": 1688824022000
    },
    {
      "minToken": 200000000,
      "maxToken": 220000000,
      "maxAmount": 5830000,
      "tokenUSDT": 0.028,
      "title": "stage_11",
      "endDate": 1689256022000
    },
    {
      "minToken": 220000000,
      "maxToken": 240000000,
      "maxAmount": 6396000,
      "tokenUSDT": 0.0283,
      "title": "stage_12",
      "endDate": 1689688022000
    },
    {
      "minToken": 240000000,
      "maxToken": 260000000,
      "maxAmount": 6968000,
      "tokenUSDT": 0.0286,
      "title": "stage_13",
      "endDate": 1690120022000
    },
    {
      "minToken": 260000000,
      "maxToken": 280000000,
      "maxAmount": 7546000,
      "tokenUSDT": 0.0289,
      "title": "stage_14",
      "endDate": 1690552022000
    },
    {
      "minToken": 280000000,
      "maxToken": 300000000,
      "maxAmount": 8130000,
      "tokenUSDT": 0.0292,
      "title": "stage_15",
      "endDate": 1690984022000
    },
    {
      "minToken": 300000000,
      "maxToken": 330000000,
      "maxAmount": 9015000,
      "tokenUSDT": 0.0295,
      "title": "stage_16",
      "endDate": 1691416022000
    },
    {
      "minToken": 330000000,
      "maxToken": 360000000,
      "maxAmount": 9909000,
      "tokenUSDT": 0.0298,
      "title": "stage_17",
      "endDate": 1691848022000
    },
    {
      "minToken": 360000000,
      "maxToken": 390000000,
      "maxAmount": 10812000,
      "tokenUSDT": 0.0301,
      "title": "stage_18",
      "endDate": 1692280022000
    },
    {
      "minToken": 390000000,
      "maxToken": 420000000,
      "maxAmount": 11724000,
      "tokenUSDT": 0.0304,
      "title": "stage_19",
      "endDate": 1692712022000
    },
    {
      "minToken": 420000000,
      "maxToken": 450000000,
      "maxAmount": 12645000,
      "tokenUSDT": 0.0307,
      "title": "stage_20",
      "endDate": 1693144022000
    },
    {
      "minToken": 450000000,
      "maxToken": 490000000,
      "maxAmount": 13885000,
      "tokenUSDT": 0.031,
      "title": "stage_21",
      "endDate": 1693576022000
    },
    {
      "minToken": 490000000,
      "maxToken": 530000000,
      "maxAmount": 15137000,
      "tokenUSDT": 0.0313,
      "title": "stage_22",
      "endDate": 1694008022000
    },
    {
      "minToken": 530000000,
      "maxToken": 570000000,
      "maxAmount": 16401000,
      "tokenUSDT": 0.0316,
      "title": "stage_23",
      "endDate": 1694440022000
    },
    {
      "minToken": 570000000,
      "maxToken": 610000000,
      "maxAmount": 17677000,
      "tokenUSDT": 0.0319,
      "title": "stage_24",
      "endDate": 1694872022000
    },
    {
      "minToken": 610000000,
      "maxToken": 650000000,
      "maxAmount": 18965000,
      "tokenUSDT": 0.0322,
      "title": "stage_25",
      "endDate": 1695304022000
    },
    {
      "minToken": 650000000,
      "maxToken": 710000000,
      "maxAmount": 20915000,
      "tokenUSDT": 0.0325,
      "title": "stage_26",
      "endDate": 1695736022000
    },
    {
      "minToken": 710000000,
      "maxToken": 770000000,
      "maxAmount": 22883000,
      "tokenUSDT": 0.0328,
      "title": "stage_27",
      "endDate": 1696168022000
    },
    {
      "minToken": 770000000,
      "maxToken": 830000000,
      "maxAmount": 24869000,
      "tokenUSDT": 0.0331,
      "title": "stage_28",
      "endDate": 1696600022000
    },
    {
      "minToken": 830000000,
      "maxToken": 900000000,
      "maxAmount": 27207000,
      "tokenUSDT": 0.0334,
      "title": "stage_29",
      "endDate": 1697032022000
    },
    {
      "minToken": 900000000,
      "maxToken": 1000000000,
      "maxAmount": 30577000,
      "tokenUSDT": 0.0337,
      "title": "stage_30",
      "endDate": 1697464022000
    }
  ]
  tokenomics2: any;
  tokenVal: any;
  isBW = false;

  constructor(
    private ref: ApplicationRef,
    private popupService: PopupService,
    private eventService: EventService,
    private http: HttpClient,
    private transletService: TranslateService,
  ) {
    /* Prevent from creating multiple instance of wallet connect service */
    if (!(WalletConnectService as any).instance) (WalletConnectService as any).instance = this;
    let tempVar = JSON.stringify(this.tokenomics);
    this.tokenomics2 = JSON.parse(tempVar);
    return (WalletConnectService as any).instance;
  }


  activateSite(): void {
    // Wagmi Core Client
    const currentChain: any = environment.isMainnet ? [bsc] : [bscTestnet];
    const { chains, publicClient, webSocketPublicClient } = configureChains(
      currentChain,
      environment.isMainnet ? [
        jsonRpcProvider({
          rpc: (chain) => ({
            http: environment.bsc.rpcURL,
          }),
        }),
        jsonRpcProvider({
          rpc: (chain) => ({
            http: environment.bsc.backupRPC,
          }),
        })
      ]
        : [publicProvider()]
    )

    this.metaMaskConnector = new MetaMaskConnector({
      chains: chains,
    })

    this.walletConnector = new WalletConnectConnector({
      chains,
      options: {
        projectId: environment.walletConnectId,
        qrModalOptions: {
          explorerRecommendedWalletIds: ['fe68cea63541aa53ce020de7398968566dfe8f3725663a564cac89490247ed49', 'c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96', '4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0']
        }
      },
    })


    this.walletConnectorBW = new WalletConnectConnector({
      chains,
      options: {
        projectId: environment.walletConnectId,
        qrModalOptions: {
          explorerRecommendedWalletIds: ['fe68cea63541aa53ce020de7398968566dfe8f3725663a564cac89490247ed49']
        }
      },
    })

    this.uriConnector = new WalletConnectConnector({
      chains,
      options: {
        showQrModal: false,
        projectId: environment.walletConnectId,
        qrModalOptions: {
          explorerRecommendedWalletIds: ['fe68cea63541aa53ce020de7398968566dfe8f3725663a564cac89490247ed49']
        }
      },
    });

    this.uriConnector.addListener('message', (uri: any) => {
      if (uri.type === 'display_uri') {
        const userAgent = window.navigator.userAgent.toLowerCase(),
          ios = /iphone|ipod|ipad/.test(userAgent);
        const bwUrl = getParamWithoutCookie('bwUrl');
        console.log("bwUrl=========>", bwUrl);
        let urlParams = uri.data + "&callbackUrl=" + window.location.href + "&browser=" + getBrowserName();
        console.log("url params=========>", urlParams);
        console.log("wondow log params=========>", window.location.href);
        if (ios) {
          const link = document.createElement('a');
          if (bwUrl && bwUrl != '') {
            link.href = bwUrl + urlParams;
            link.click();
            this.isBW = true;
          } else {
            link.href = environment.bwUniversalLink + '/connect?' + urlParams;
            link.target = '_blank';
            link.click();
            this.isBW = false;
          }
        } else {
          if (bwUrl && bwUrl != '') {
            const link = document.createElement('a');
            link.href = bwUrl + urlParams;
            link.click();
            this.isBW = true;
          } else {
            const link = document.createElement('a');
            link.href = environment.bwUniversalLink + "/connect?" + urlParams;
            link.target = '_blank';
            link.click();
            this.isBW = false;
          }
        }
      }
    });

    // ============= create we3Auth modal ===================

    const chainConfig = {
      chainNamespace: CHAIN_NAMESPACES.EIP155,
      chainId: "0x" + chains[0].id.toString(16),
      rpcTarget: environment.bsc.chainInfo.params[0].rpcUrls[0],
      displayName: chains[0].name,
      tickerName: chains[0].nativeCurrency?.name,
      ticker: chains[0].nativeCurrency?.symbol,
    };
    const privateKeyProvider = new EthereumPrivateKeyProvider({ config: { chainConfig } });

    this.web3AuthInstance = new Web3Auth({
      clientId: web3clientId,
      web3AuthNetwork: environment.isMainnet ? "mainnet" : "testnet",
      privateKeyProvider,
      chainConfig,
      uiConfig: {
        appName: 'Wall Street Memes',
        mode: "dark",
        useLogoLoader: true,
        uxMode: "popup",
        loginMethodsOrder: ["google"],
        logoLight: "https://web3.wsmcasino.com/assets/images/web3-wall--street.png", // Your App Logo Here
        logoDark: "https://web3.wsmcasino.com/assets/images/web3-wall--street.png", // Your App Logo Here
        theme: { primary: '#ffe34d', onPrimary: '#222325', },
        loginGridCol: 3,
        primaryButton: "emailLogin",
      }
    });


    // ============= add walletServices Plugin ===================

    const walletServicesPlugin = new WalletServicesPlugin({
      walletInitOptions: {
        whiteLabel: {
          showWidgetButton: true, 
          useLogoLoader: true, 
          mode: "dark",
          appName: 'Wall Street Memes',
          buttonPosition: 'bottom-left',
          theme: { primary: "#eb4a39", onPrimary: '#222325'},
          defaultPortfolio : 'token',
          logoDark: "https://web3.wsmcasino.com/assets/images/web3-wall--street.png",
          // logoLight: "https://web3.wsmcasino.com/assets/images/web3-wall--street.png",
        },
        confirmationStrategy: "modal",
      }
    });
    
    
    // ============= add auth adapter ===================

    const authAdapter = new AuthAdapter({
      adapterSettings: {
        loginConfig: {
          // Google login
          google: {
            name: "Wall Street Memes",
            verifier: "wall-street-memes", // Please create a verifier on the developer dashboard and pass the name here
            typeOfLogin: "google", // Pass on the login provider of the verifier you've created
            clientId: googleClientId //,"GOOGLE_CLIENT_ID.apps.googleusercontent.com", // Pass on the clientId of the login provider here - Please note this differs from the Web3Auth ClientID. This is the JWT Client ID
          },
          facebook:{ 
            typeOfLogin: 'facebook', 
            showOnModal: false, 
            verifier: 'none'
          }
        },
      },
      privateKeyProvider,
    });

    this.web3AuthInstance.configureAdapter(authAdapter);
    this.web3AuthInstance.addPlugin(walletServicesPlugin);

    
    // ============= create Web3Auth connector ===================

    this.web3AuthConnector = new Web3AuthConnector({
      chains,
      options: {
        web3AuthInstance: this.web3AuthInstance,
      },
    })

    this.client = createConfig({
      autoConnect: true,
      connectors: [this.metaMaskConnector, this.walletConnector, this.web3AuthConnector, this.walletConnectorBW, this.uriConnector],
      publicClient,
      webSocketPublicClient,
    });

    watchNetwork((network: any) => {
      this.chainId = network?.chain?.id;
      this.eventService.isBsc = true;
      this.getPresalesData();
      if (this.wagmiData?.isConnected) this.getMetaData();
      setTimeout(() => this.eventService.setNetwork(), 2000);
      this.ref.tick();
      console.log('watchNetwork =', network);
    });

    watchAccount((account: any) => this.setData(account));
  }


  isCorrectChain(): boolean {
    return (this.chainId === environment.bsc.chainIdInt);
  }

  isEthChain(): boolean {
    return this.chainId === environment.bsc.chainIdInt ? true : false;
  }

  async connectWallet(mode: string) {
    this.mode = mode;
    this.eventService.broadcastEvent(EVENTS.WALLET_CONNECTION, true);
    await connect({
      connector: mode === 'metamask' ? this.metaMaskConnector
        : mode === 'wallet' ? this.walletConnector
          : mode === 'walletBW' ? this.walletConnectorBW
            : mode === 'bw' ? this.uriConnector
              : this.web3AuthConnector
    })
      .then((success: any) => {
        console.log('\n======= wallet connected ==========\n', this.client, '\n======================');
        this.checkWallet();
        setTimeout(() => {
          this.sendDashFx('', 0, 0, true);
          this.windowDataLayer('connectWallet', 'successful', 2, 1, 0, '', '', 0, 0);
          this.eventService.broadcastEvent(EVENTS.WALLET_CONNECTION, false);
        }, 2000);
      },
        (err: any) => {
          console.log('\n======= wallet connection issue ==========\n', err);
          this.eventService.broadcastEvent(EVENTS.WALLET_CONNECTION, false);
        })
  }

  async disConnectWallet() {
    this.eventService.broadcastEvent(EVENTS.WALLET_CONNECTION, true);
    await disconnect()
      .then((success: any) => {
        // console.log('\n======= wallet disconnected ==========\n',this.client);
        // localStorage.clear();
        this.referUrl = '';
        this.chainId = null;
        this.walletAddress = '';
        this.balanceData.nativeBal = 0;
        this.balanceData.usdtBal = 0;
        this.eventService.setNetwork();
        this.eventService.broadcastEvent('IS_WEB3', false);
        this.eventService.broadcastEvent(EVENTS.WALLET_CONNECTION, false);
        this.eventService.isConnected = false;
      },
        (err: any) => {
          console.log('\n======= wallet disconnect issue ==========\n');
          console.log('disconnect issue =', err);
        })
  }

  setData(account: any): void {
    this.wagmiData = account;
    this.walletAddress = this.wagmiData.address;
    this.eventService.isConnected = account.address ? true : false;
    this.refer();
    this.ref.tick();
    this.getPresalesData();
    if (this.wagmiData?.isConnected) this.getMetaData();
    // console.log('wagmiData', this.wagmiData);
  }

  async getPresalesData(getData: boolean = false) {

    if (this.walletAddress && this.referUrl == '') {
      this.refer()
    }
    const config = {
      contracts: [
        {
          ...presaleContractBsc,
          functionName: 'newUserDeposits',
          chainId: environment.bsc.chainIdInt, // 0
          args: [this.walletAddress || "0x0000000000000000000000000000000000000000"]
        },
        {
          ...presaleContractBsc,
          functionName: 'totalTokensSold',
          chainId: environment.bsc.chainIdInt, //  1
          args: []
        }, {
          ...stakeContract,
          functionName: 'poolStakers',
          chainId: environment.bsc.chainIdInt, // 2
          args: [this.walletAddress || "0x0000000000000000000000000000000000000000"]
        },
        {
          ...stakeContract,
          functionName: 'getRewards',
          chainId: environment.bsc.chainIdInt, // 3
          args: [this.walletAddress || "0x0000000000000000000000000000000000000000"]
        },
        {
          ...stakeContract,
          functionName: 'rewardTokensPerBlock',
          chainId: environment.bsc.chainIdInt, // 4
          args: []
        },
        {
          ...stakeContract,
          functionName: 'tokensStaked',
          chainId: environment.bsc.chainIdInt, //5
          args: []
        },
        {
          ...stakeContract,
          functionName: 'harvestLock',
          chainId: environment.bsc.chainIdInt, //6
          args: []
        },
        {
          ...presaleContractBsc,
          functionName: 'fetchPrice',
          chainId: environment.bsc.chainIdInt, //7
          args: [1000000000000000000]  // equal to 1 in ethers
        },
        {
          ...presaleContractBsc,
          functionName: 'getLatestPrice',
          chainId: environment.bsc.chainIdInt, //8
          args: []
        },
        {
          ...presaleContractBsc,
          functionName: 'maxTokensToSell',
          chainId: environment.bsc.chainIdInt, //9
          args: []
        },
        {
          ...presaleContractBsc,
          functionName: 'directTotalTokensSold',
          chainId: environment.bsc.chainIdInt, //10
          args: []
        },
        {
          ...presaleContractBsc,
          functionName: 'claimStart',
          chainId: environment.bsc.chainIdInt, //11
          args: []
        },
        {
          ...stakeContract,
          functionName: 'lockedTime',
          chainId: environment.bsc.chainIdInt, //12
          args: []
        },
        {
          ...tokenContract,                   // 13
          functionName: 'totalSupply',
          chainId: environment.bsc.chainIdInt,
          args: [],
        },
        {
          ...tokenContract,                   // 14
          functionName: 'balanceOf',
          chainId: environment.bsc.chainIdInt,
          args: ['0x000000000000000000000000000000000000dEaD'],
        },
      ]
    }

    this.presaleData = await readContracts(config);
    // console.log('presale contract data ===', this.presaleData)


    // Stake data
    if (this.walletAddress) {
      let wsmBalance = await fetchBalance({
        address: this.walletAddress as any,
        formatUnits: 'ether',
        token: environment.tokenAddress as any,
        chainId: environment.bsc.chainIdInt
      });
      // this.stakeData.userBal = +(+wsmBalance.formatted).toFixed(2); 
      this.stakeData.userBal = Math.floor(+wsmBalance.formatted *100)/100;
    }
    this.stakeData.userStaked = +formatEther(this.presaleData[2].result[0] || 0);
    this.stakeData.unlockTime = Number(this.presaleData[2].result[1]) + Number(this.presaleData[12].result);
    this.stakeData.claimDate = 1695718800 + Number(this.presaleData[12].result);
    this.stakeData.userReward = +formatEther(this.presaleData[3]?.result[0] || 0);
    this.stakeData.userReward += +formatEther(this.presaleData[3]?.result[1] || 0); // 5% bonus
    this.stakeData.rewardPerRound = +formatEther(this.presaleData[4].result || 0);
    this.stakeData.totalStaked = +formatEther(this.presaleData[5].result || 0);
    this.stakeData.isClaimEnabled = !this.presaleData[6].result || false;
    this.stakeData.apy = +((+environment.apyCalcConst / (this.stakeData.totalStaked > 0 ? this.stakeData.totalStaked : 1)) * 100).toFixed(0);

    // console.log('\n******\presaleData =', this.presaleData, this.stakeData, '\n******\n');

    this.balanceData.currentStep = this.tokenomics.length - 1;

    this.balanceData.ethTokenSold = Number(this.presaleData[1].result);
    this.balanceData.totalTokensSold = this.balanceData.ethTokenSold;
    this.balanceData.ethClaimable = +formatEther(this.presaleData[0].result || 0);
    this.balanceData.userClaimable = this.balanceData.ethClaimable;
    let oneWsmEth = +formatEther(this.presaleData[7].result as any);
    let ethUsdt = +formatEther(this.presaleData[8].result as any);
    this.tokenVal = oneWsmEth * ethUsdt;
    let maxTokensToSell = +Number(this.presaleData[9].result);
    let directTotalTokensSold = +Number(this.presaleData[10].result);
    this.balanceData.tokenNum = maxTokensToSell - directTotalTokensSold;
    this.tokenVal = oneWsmEth * ethUsdt;

    // ================= BURNT DATA ===============
   
    this.burnData.totalSupply = +formatEther(this.presaleData[13].result || 0);
    const balanceOf = +formatEther(this.presaleData[14].result || 0);
    this.burnData.totalBurnt = 2000000000 - this.burnData.totalSupply + balanceOf;
    this.burnData.totalBurntCommunity = this.burnData.totalBurnt;// - 2257336.3;


    if (this.walletAddress && this.walletAddress != '') {
      this.getMetaData();
    }

    if (this.refreshId) clearTimeout(this.refreshId);
    this.refreshId = setTimeout(() => this.getPresalesData(), this.refreshRate);
    // console.log('\n******\nbalanceData RPC =  =', this.balanceData, '\n******\n');

    // console.log('\n******\n burnData RPC =', this.burnData, '\n******\n');

  }

  async getMetaData() {
    const walletAddress = this.walletAddress.slice();
    let nativeBalance = await fetchBalance({
      address: walletAddress as any,
      formatUnits: 'ether',
      chainId: environment.bsc.chainIdInt
    })
    let usdtBal = await fetchBalance({
      address: walletAddress as any,
      // formatUnits: 'mwei',
      token: environment.bsc.usdTAddress as any,
      chainId: environment.bsc.chainIdInt
    })

    this.balanceData.nativeBal = +nativeBalance.formatted;
    this.balanceData.usdtBal = +usdtBal.formatted;
  }

  get tokenSoldData() {
    for (let soldData of this.tokenomics) {
      if (soldData.maxToken >= this.soldToken && soldData.endDate > (Date.parse(new Date().toString()) / 1000)) {
        return soldData;
      }
    }
    return this.tokenomics[this.tokenomics.length - 1];
  }

  get soldToken() {
    return this.balanceData.totalTokensSold;
    // return this.balanceData.usdRaised;
  }

  async switchNetwork(chainId: number) {
    await switchNetwork({
      chainId: chainId,
    }).then((success: any) => {
      this.ref.tick();
    },
      (err: any) => {
        const chain = environment.bsc.chainInfo
        const chainName = chain.params[0].chainName;
        this.popupService.messagePopup("info", this.transletService.instant('switchNetwork', { chain_name: chainName }));
      });
  }

  getUSDTAmount(amount: number) {
    let singleAmount = this.tokenVal;
    return Math.floor(+(amount / (+singleAmount)));
  }

  getUSDTAmountRev(amount: number) {
    let singleAmount = this.tokenVal;
    return +((+singleAmount) * amount);
  }

  getEthAmount = async (amount: number) => {
    console.log('getEthAmount called')
    let singleAmount = +formatEther(this.presaleData[7].result);
    return Math.floor(+(amount / (+singleAmount)));
  }

  getEthAmountRev = async (amount: number) => {
    console.log('getEthAmount called')
    let singleAmount = +formatEther(this.presaleData[7].result);
    return +(amount * (+singleAmount));
  }

  //  ************* SwapBNB Token **************

  async swapBnbTokens(amount: number, value: number, isStake: boolean) {
    console.log('swapBnbTokens called');
    this.swapStatus = SwapStatus.not_started;
    const { request } = await prepareWriteContract({
      ...presaleContractBsc,
      functionName: "buyWithBNB",
      chainId: this.chainId,
      // args:  [amount, isStake],
      args:  [amount, false],
      value: parseEther(`${value}`),
      // account: this.walletAddress    // Optional param. Not required!
    })
    this.swapStatus = SwapStatus.confirm_pending;
    await writeContract(request)
      .then((success: any) => {
        console.log('Eth write Contract success', success);
        this.swapStatus = SwapStatus.in_progess;
        this.windowDataLayer('swap', 'confirmTransaction', 2, 0, 0);
        this.sendDashFx('ETH', amount, value);
        this.checkTRansaction(success.hash, 'ETH', amount, value);
      },
        (err: any) => {
          if (err.code === 4001) {
            this.swapStatus = SwapStatus.rejected;
          } else {
            this.swapStatus = SwapStatus.failed;
          }
        });

  }


  //  ************* Swap USDT Token **************

  async swapCryptoForUSDT(amount: number, value: number, afterAllowance: boolean, isStake: boolean) {

    const presaleAdd = environment.bsc.presaleAddress as any;
    const allowanceData = await readContracts({
      contracts: [
        {
          ...bscUsdtContract,
          functionName: 'allowance',
          chainId: this.chainId,
          args: [this.walletAddress, presaleAdd],
        },
      ],
    })
    let allowanceValue;
    if (this.eventService.isBsc) {
      allowanceValue = +formatEther(allowanceData[0].result as any);
    } else {
      allowanceValue = Number(allowanceData[0].result) / Math.pow(10, 6);
    }
    console.log('allowanceData =', value, allowanceValue);

    if (+value > +allowanceValue) {
      const { request } = await prepareWriteContract({
        ...bscUsdtContract,
        chainId: this.chainId,
        functionName: 'approve',
        args: [presaleAdd, (afterAllowance || allowanceValue == 0) ? '100000000000000000000000000' : '0'],
        account: this.walletAddress as any    // Optional param. Not required!
      })

      console.log('approveConfig =', request)
      this.swapStatus = SwapStatus.approval_pending;
      const { hash } = await writeContract(request);
      console.log('hash =', hash)
      await waitForTransaction({ hash })
        .then((success: any) => {
          console.log('approve Config success', success);
          if (afterAllowance) {
            this.buyUSDT(amount, value, isStake);
          } else {
            this.swapCryptoForUSDT(amount, value, true, isStake);
          }
        },
          (err: any) => {
            console.log('approve Config error', err);
            this.swapStatus = SwapStatus.rejected;
          });
    } else {
      this.buyUSDT(amount, value, isStake);
    }
  }


  //  ************* Buy USDT **************

  async buyUSDT(amount: number, value: number, isStake: boolean) {
    const contract = presaleContractBsc;
    const { request } = await prepareWriteContract({
      ...contract,
      functionName: 'buyWithUSDT',
      chainId: this.chainId,
      // args: [amount, isStake]
      args: [amount, false]
      // account: this.walletAddress  // Optional param. Not required!
    });

    console.log('usdtConfig =', request)
    this.swapStatus = SwapStatus.confirm_pending;
    await writeContract(request)
      .then((success: any) => {
        console.log('Eth writeContract success', success);
        this.windowDataLayer('swap', 'confirmTransaction', 2, 0, 0);
        this.swapStatus = SwapStatus.in_progess;
        this.sendDashFx('usdt', amount, value);
        this.checkTRansaction(success.hash, 'usdt', amount, value);
      },
        (err: any) => {
          console.log('Eth writeContract error', err);
          this.swapStatus = SwapStatus.failed;
        });
  }

  async checkTRansaction(haskKey: string, mode: string, amount: number, value: number, isDatalayer: boolean = true) {
    await waitForTransaction({ hash: haskKey as any })
      .then((response: any) => {
        console.log('checkTansaction success', response);
        this.swapStatus = SwapStatus.complete;
        this.swapHash = response.transactionHash;
        this.sendBWData(mode, amount, value);
        if (isDatalayer) this.windowDataLayer('swap', 'swapSuccessful', 3, 1, 0, mode, environment.tokenName, value, amount);
        this.getMetaData();
      },
        (err: any) => {
          console.log('checkTansaction error', err);
          this.swapStatus = SwapStatus.failed;
        });
  }


  windowDataLayer(flowName: string, stepName: string, stepNo: number, completeFlag: number, errorCode: number, fromCurrency: string = '', toCurrency: string = '', fromVal: number = 0, toVal: number = 0): void {

    window.dataLayer = [];
    window.dataLayer.push({
      event: "workflowStep",
      walletAddress: this.walletAddress,
      workflowName: flowName,                                               // "swap",
      workflowStepNumber: stepNo,                                           // 2,
      workflowStepName: stepName,                                           // "confirmTransaction",

      workflowCompleteFlag: completeFlag,
      workflowErrorCode: errorCode,

      transactionId: completeFlag === 0 ? undefined : this.swapHash,
      swapFromValue: completeFlag === 0 ? undefined : fromVal,                // value,
      swapToValue: completeFlag === 0 ? undefined : toVal,                    // amount,
      swapFromCurrency: completeFlag === 0 ? undefined : fromCurrency,        // "USDT",
      swapToCurrency: completeFlag === 0 ? undefined : toCurrency,            // "$WSM"
    });
  }

  // ==== DashFx ====

  sendDashFx = (type: string, toValue: number, fromValue: number, connectMode: boolean = false) => {
    const tokens: any = (this.balanceData.ethClaimable || 0) + (this.balanceData.bscClaimable || 0);
    const data = {
      walletAddress: this.walletAddress,
      iid: environment.iidDashFx,
      event: connectMode ? 'lead_success' : (tokens > toValue ? 'revenue' : 'conversion'),
      purchaseType: connectMode ? null : type,
      purchaseTokens: +toValue,
      purchaseTypeAmount: +fromValue,
      purchaseUsdAmount: type === 'usdt' ? +fromValue : +(+(toValue * this.tokenSoldData.tokenUSDT).toFixed(2)),
      ipAddress: '',
      clickId: getClickId(),
      source: getSource(),
      tsid: this.isBW ? 1706 : getParam('tsid'),
      pid: getParam('pid')
    }
    console.log('DashFx data =', tokens, data)
    // this.http.post(environment.urlDashFx, data).subscribe((res: any) => {
    //   console.log('DashFx success response', res);
    // },
    //   (err: any) => {
    //     console.log('DashFx error response', err);
    //   })
  }

  async getABI(amount: number, isStake: boolean): Promise<string> {
    const data = encodeFunctionData({
      abi: presaleBsc.abi,
      functionName: isStake ? 'buyWithEthWertDynamic' : 'buyWithEthWert',
      args: [this.walletAddress, amount]
    })
    return data;
  }

  async claim() {
    console.log('Claim called');
    const { request } = await prepareWriteContract({
      ...presaleContractBsc,
      functionName: 'claim',
      chainId: environment.bsc.chainIdInt,
      args: [],
      // account: this.walletAddress  // Optional param. Not required!
    })
    await writeContract(request)
      .then((success: any) => {
        console.log('Claim success', success);
      },
        (err: any) => {
          console.log('Claim error', err);
        });
  }


  refer() {
    /*if (!this.walletAddress || this.walletAddress == '')
      return;
    const data = {
      walletAddress: this.walletAddress,
      iid: environment.iidDashFx,
    }
    this.http.post(environment.referUrl, data).subscribe((res: any) => {
      console.log('refer success response', res);
      this.referUrl = res.data.url
    },
    (err: any) => {
      console.log('DashFx error response', err);
    });*/
  }

  checkWallet(): boolean {
    const isConnected = localStorage.getItem('wagmi.connected');
    const isWallet = localStorage.getItem('wagmi.wallet');
    const returnMode = isConnected === 'true' && isWallet === '"web3auth"' ? true : false;
    this.eventService.broadcastEvent('IS_WEB3', returnMode);
    return returnMode
  }

  async claimStake() {
    console.log('Claim called');
    this.swapStatus = SwapStatus.in_progess
    const { request } = await prepareWriteContract({
      ...presaleContractBsc,
      functionName: 'claimAndStake',
      chainId: environment.bsc.chainIdInt,
      args: [],
      // account: this.walletAddress  // Optional param. Not required!
    })
    await writeContract(request)
      .then((success: any) => {
        console.log('claimStake success', success);
        this.checkTRansaction(success.hash, 'claimstake', 0, 0);   // checking transaction status
      },
        (err: any) => {
          console.log('claimStake error', err);
          this.swapStatus = SwapStatus.failed
        });
  }

  async claimStakeRewards() {
    console.log('Claim called');
    const { request } = await prepareWriteContract({
      ...stakeContract,
      functionName: 'harvestRewards',
      chainId: environment.bsc.chainIdInt,
      args: [],
      // account: this.walletAddress  // Optional param. Not required!
    })
    await writeContract(request)
      .then((success: any) => {
        console.log('claimStake success', success);
      },
        (err: any) => {
          console.log('claimStake error', err);
        });
  }

  async withdrawStake() {
    console.log('Claim called');
    const { request } = await prepareWriteContract({
      ...stakeContract,
      functionName: 'withdraw',
      chainId: environment.bsc.chainIdInt,
      args: [],
      // account: this.walletAddress  // Optional param. Not required!
    })
    await writeContract(request)
      .then((success: any) => {
        console.log('claimStake success', success);
      },
        (err: any) => {
          console.log('claimStake error', err);
        });
  }

  async createStake(amount: any, afterAllowance: boolean = false) {
    const allowanceData = await readContracts({
      contracts: [
        {
          ...tokenContract,
          functionName: 'allowance',
          chainId: this.chainId,
          args: [this.walletAddress, environment.stakingAddress],
        },
      ],
    })
    const allowanceValue = +formatEther(allowanceData[0].result as any);
    console.log('createStake allowanceData =', allowanceData, allowanceValue);
    // const allowanceValue = allowanceData[0] as any;

    if (amount > +allowanceValue) {
      const { request } = await prepareWriteContract({
        ...tokenContract,
        chainId: this.chainId,
        functionName: 'approve',
        args: [environment.stakingAddress, '100000000000000000000000000'],
        // account: this.walletAddress  // Optional param. Not required!

      })

      console.log('approveConfig =', request)
      this.swapStatus = SwapStatus.approval_pending;
      let hash: any;
       await writeContract(request).then((success: any) => {
        hash = success;
      }).catch((err: any) => {
        this.swapStatus = SwapStatus.rejected;
        console.log('approveConfig error', err);
      });
      console.log('createStake approveConfig hash =', hash)
      await waitForTransaction({ hash })
        .then((success: any) => {
          console.log('approveConfig approve Config success', success);
          this.swapStatus = SwapStatus.confirm_pending;
          if (afterAllowance) {
            this.proceedCreateStake(amount);
          } else {
            this.createStake(amount, true);
          }
        },
          (err: any) => {
            console.log('approve Config error', err);
            if (err.code === 4001) {
              this.swapStatus = SwapStatus.rejected;
            } else {
              this.swapStatus = SwapStatus.failed;
            }
          });
    } else {
      this.proceedCreateStake(amount);
    }
  }

  async proceedCreateStake(amount: any) {

    const { request } = await prepareWriteContract({
      ...stakeContract,
      functionName: 'deposit',
      chainId: environment.bsc.chainIdInt,
      args: [amount * Math.pow(10, 18)]
    })

    this.swapStatus = SwapStatus.confirm_pending;
    await writeContract(request)
      .then((success: any) => {
        console.log('proceedCreateStake success', success);
        this.swapStatus = SwapStatus.in_progess;
        this.checkTRansaction(success.hash, '', amount, 0, false);
      },
        (err: any) => {
          console.log('Eth createStake error', err);
          if (err.code === 4001) {
            this.swapStatus = SwapStatus.rejected;
          } else {
            this.swapStatus = SwapStatus.failed;
          }
        });
  }

  async getStakeData() {
    const config = {
      contracts: [
        {
          ...stakeContract,
          functionName: 'rewardTokensPerBlock',
          chainId: environment.bsc.chainIdInt, //0
          args: []
        },
        {
          ...stakeContract,
          functionName: 'tokensStaked',
          chainId: environment.bsc.chainIdInt, //1
          args: []
        }]
    };
    let tempData: any = await readContracts(config);
    // Stake data

    this.stakeData.rewardPerRound = +formatEther(tempData[0].result || 0);
    this.stakeData.totalStaked = +formatEther(tempData[1].result || 0);
    this.stakeData.apy = +((+environment.apyCalcConst / (this.stakeData.totalStaked > 0 ? this.stakeData.totalStaked : 1)) * 100).toFixed(0);
  }

  async burnToken(amount: any) {
    console.log('burnToken called');
    const { request } = await prepareWriteContract({
      ...tokenContract,
      functionName: 'burn',
      chainId: environment.bsc.chainIdInt,
      args: [amount * Math.pow(10, 18)],
      // account: this.walletAddress  // Optional param. Not required!
    })

    await writeContract(request)
      .then((success: any) => {
        console.log('burnToken success', success);
        this.popupService.messsageAlert('success', this.transletService.instant("burn_success_msg"));
      },
        (err: any) => {
          console.log('burnToken error', err);
          this.popupService.messsageAlert('error', this.transletService.instant("burn_error_msg"));
        });
  }

  /**
 * BestWallet Data analytics
 * @param type : connect wallet/ETH/BNB/USDT
 * @param toValue: App token value
 * @param fromValue :BNB/BNB/USDT value
 * @param connectMode: whether it is wallet connect or not
 */

  sendBWData = (type: string, toValue: number, fromValue: number) => {
    // if (environment.production) {
    const tokens: any = (this.balanceData.ethClaimable || 0);
    const data = {
      publicAddress: this.walletAddress,
      event: (tokens > toValue ? 'revenue' : 'conversion'),
      purchaseType: type,
      purchaseTokens: +toValue,
      purchaseTypeAmount: +fromValue,
      purchaseUsdAmount: type === 'usdt' ? +fromValue : +(+(toValue * this.tokenSoldData.tokenUSDT).toFixed(2)),
      ipAddress: '',
      clickId: getParam('clickId'),
      source: getParam('source'),
      hash: this.swapHash,
      chainId: this.chainId,
      presaleName: "WSM-TOKEN",
      isBW: this.isBW
    }

    console.log('BW data =', tokens, data)
    this.http.post(environment.bwApiUrl, data).subscribe((res: any) => {
      console.log('BW success response', res);
    },
      (err: any) => {
        console.log('BW error response', err);
      });
    // }
  }
}
